"use strict";

exports.__esModule = true;
exports.init = void 0;
var _downloadImage = _interopRequireDefault(require("../../../img/download-image.jpg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const init = data => {
  if (!data.headerImage) {
    data.headerImage = _downloadImage.default;
  } else {
    data.headerImage = `/${data.headerImage}`;
  }
  if (!data.downloadText) {
    data.downloadText = "Download for Windows";
  }
  if (!data.downloadTextMac) {
    data.downloadTextMac = "Download for macOS";
  }
  if (!data.headerText) {
    data.headerText = "Name of the app here";
  }
  if (!data.descriptionText) {
    data.descriptionText = "In order to get the full experience with this product, please download the Windows application by clicking this button.";
  }
  if (!data.additionalText) {
    data.additionalText = "After you successfully download the application, unpack it by right-clicking on the downloaded file and selecting 'Extract all…'. You can then double-click the file in the unpacked folder, like any other program that you use, to start it. You only have to download this application from this website the first time you want to use it. After this, the program automatically updates itself if a new version is available.";
  }
  return dispatch => {
    dispatch({
      type: 'INIT_DOWNLOADAPP',
      data: data
    });
  };
};
exports.init = init;